import { render, staticRenderFns } from "./ReleaseButton.vue?vue&type=template&id=599c9f38&scoped=true&"
import script from "./ReleaseButton.vue?vue&type=script&lang=js&"
export * from "./ReleaseButton.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseButton.vue?vue&type=style&index=0&id=599c9f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599c9f38",
  null
  
)

export default component.exports